import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, Input, Modal, Select, FormProps, FormInstance } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { addCategoryCar } from "../../../../../api/categoryCar/categoryCarApi"
import { useForm } from "antd/lib/form/Form"
import { ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { getCLCarLines, getCLTypeVehicle, getCLVehicle, getCLVehicleGroup } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
import { CARTYPE } from "../../../../../services/data"
interface ModalProps {
  isOpen: boolean
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void;
  closeModal: () => void
}
const ModalCreateBrand: React.FC<ModalProps> = ({
  isOpen,
  onSubmitFormModal, closeModal
}) => {

  const { CAR_BUS, CAR } = CARTYPE
  const imgRef = useRef<HTMLInputElement>(null);
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const isProgrammaticSet = useRef(false);
  const carLineId = Form.useWatch("carLineId", form);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLTypeVehicle = async () => {
    if (!carLineId) return
    const result = await getCLTypeVehicle(carLineId)
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setUploadedFile(file);
  };

  const handleUploadClick = (event: React.MouseEvent) => {

    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const {
      code, title, carLineId,
      image, typeVehicleId,
    } = values
    const result = await addCategoryCar(
      code, title, image,
      carLineId, typeVehicleId,
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (carLineId && carLineId === CAR) {
      gCLTypeVehicle()
    }
    form.setFieldValue("typeVehicleId", undefined);
  }, [carLineId]);

  useEffect(() => {
    if (isOpen) {
      if (!cLCarLines.length)
        gCLCarLines()
    } else {
      isProgrammaticSet.current = false
      setUploadedFile(null)
      form.resetFields()
    }
  }, [isOpen]);

  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
      requiredMark={true}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">
            Tạo mới thương hiệu xe
          </span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={closeModal}
          />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer"
              onClick={closeModal}
            >
              Huỷ
            </span>
            <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}>
              Lưu
            </button>
          </div>
        }
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex flex-column">
            <div className="border-F2F4F7 rounded-2-px w-104-px h-104-px bg-F9FAFB d-flex align-center justify-center relative"
            >
              {uploadedFile ? (
                <img
                  src={URL.createObjectURL(uploadedFile)}
                  alt="Uploaded"
                  className="w-104-px  rounded-3 cursor-pointer"
                  onClick={() => (imgRef as any).current.click()}
                />
              ) : (
                <div
                  className="d-flex flex-column align-center gap-2 cursor-pointer"
                  onClick={handleUploadClick}
                >
                  <PlusOutlined className="text-sm text-252626" />
                  <span className="text-sm text-98A2B3 text-center">
                    Tải lên <br /> Logo
                  </span>
                </div>
              )}


            </div>
            <Form.Item
              className='custom-err-modal'
              name="image"
              // rules={[{ required: true, message: "Vui lòng tải lên logo!" }]}
              valuePropName="file"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) return e;
                return e?.target?.files?.[0];
              }}
            >
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={imgRef}
                onChange={handleFileChange}
              />
            </Form.Item>
          </div>
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-4">

              <Form.Item

                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="carLineId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select
                  allowClear
                  options={cLCarLines}
                />
              </Form.Item>
            </div>
            {carLineId === CAR &&
              <div className="d-flex flex-column gap-1">
                <Form.Item
                  label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                  layout="vertical"
                  name="typeVehicleId"
                  className="m-none-form-item text-explan text-label"
                  rules={[{ required: true, message: 'Chọn loại xe!' }]}
                >
                  <Select
                    disabled={!carLineId}
                    allowClear
                    options={cLTypeVehicle}
                  />
                </Form.Item>
              </div>
            }
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã thương hiệu xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã thương hiệu xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Tên thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập tên thương hiệu xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Tên thương hiệu xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
        </div>

      </Modal>
    </Form>
  )
}
export default ModalCreateBrand
